
angular.module('bmsApp.directives').factory('ChangeLogSvc', [
    '$q',
    '$rootScope',
    '$modal',
    'notify',
    'CRUDSvc',
    'CHANGE_LOG_API', function (
        $q,
        $rootScope,
        $modal,
        notify,
        CRUDSvc,
        CHANGE_LOG_API) {


        let functions =
        {

            index: function (params) {
                return CRUDSvc.get(CHANGE_LOG_API.INDEX, params);
            },
            read: function (params) {
                return CRUDSvc.post(CHANGE_LOG_API.READ, params);
            },
            checkUnread: function(params) {
                return CRUDSvc.get(CHANGE_LOG_API.UNREAD, params);
            },
            showModal: function () {
                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: 'ng/global/changelog/templates/ChangeLogModal.html',
                    controller: 'ChangeLogModalCtrl',
                    size: 'lg',
                    scope: $rootScope,
                    backdrop: 'static' // disable click-outside closing modal
                });

                return modalInstance.result;
            }

        };
        return functions;



    }]).constant('CHANGE_LOG_API', {
    INDEX: 'api/changelog/index',
    READ: 'api/changelog/read',
    UNREAD: 'api/changelog/unread',
});
